import React, {CSSProperties, ReactElement, ReactNode, forwardRef} from 'react';
import {Skeleton} from '@mui/material';
import classNames from 'classnames';
import styles from './styles.module.scss';

type BlurredCardContentProps = Pick<CSSProperties, 'minHeight'> & {
  children: ReactNode;
  blur?: boolean;
  blurText?: string;
  loading?: boolean;
  // Used to position the card content for full page layout
  fullPageTop?: number;
  padding?: boolean;
  useZindex?: boolean;
  minHeight?: string | number;
};

function BlurredCardContent(props: BlurredCardContentProps, ref): ReactElement {
  props = {
    useZindex: true,
    ...props,
  };

  const classes = classNames(styles.container, {
    [styles.padding]: props.padding,
  });

  if (!props.blur && !props.loading) {
    return (
      <div className={classes} ref={ref}>
        {props.children}
      </div>
    );
  }

  const BlurStyled = props.blur ? styles.blurClasses : undefined;

  return (
    <div
      ref={ref}
      className={classes}
      style={{
        minHeight: `${props.minHeight}px`,
        height: `calc(100% - ${props.fullPageTop || 75}px)`,
      }}
    >
      {props.loading ? null : (
        <span
          className={classNames(styles.blurText, {[styles.noZindexBlurText]: !props.useZindex})}
        >
          {props.blurText}
        </span>
      )}
      <div className={classNames(styles.contentContainer, BlurStyled)}>
        {props.loading ? <Skeleton width="100%" height={props.minHeight || 100} /> : props.children}
      </div>
    </div>
  );
}

export default forwardRef(BlurredCardContent);
